import React, { memo, Fragment } from 'react';
import { compact } from 'lodash';
/* Utils */
import { highlightQuery } from 'site-modules/shared/utils/inventory/global-search-links';
/* Constants */
import {
  GlobalSearchLinkDefaultProps,
  GlobalSearchLinkPropTypes,
  LinkConfigEntity,
} from 'site-modules/shared/constants/global-search/global-search-prop-types';
/* Components */
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { RatingStars } from 'site-modules/shared/components/rating-stars/rating-stars';
import { GlobalSearchLink } from 'site-modules/shared/components/inventory/global-search/global-search-links/global-search-link';
import { LinkIcon } from 'site-modules/shared/components/inventory/global-search/link-icon/link-icon';

export const DealerGlobalSearchLink = memo(props => {
  const {
    query,
    linkConfig: { title, icon, rating, mileage, address },
  } = props;

  return (
    <GlobalSearchLink {...props}>
      <LinkIcon icon={icon} />
      <div className="d-flex align-items-center">
        <span className="fw-bold d-block">
          <ContentFragment componentToUse="span">{highlightQuery({ userInput: query, title })}</ContentFragment>
          {(rating || mileage || address) && (
            <span className="fw-normal d-block medium text-cool-gray-40">
              {compact([
                rating && <RatingStars rating={rating} starClass="medium text-cool-gray-40" />,
                mileage,
                address,
              ]).map((linkData, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Fragment key={`link-data-${index}`}>
                  {!!index && ' | '}
                  {linkData}
                </Fragment>
              ))}
            </span>
          )}
        </span>
      </div>
    </GlobalSearchLink>
  );
});

DealerGlobalSearchLink.displayName = 'DealerGlobalSearchLink';

DealerGlobalSearchLink.propTypes = {
  ...GlobalSearchLinkPropTypes,
  linkConfig: LinkConfigEntity,
};

DealerGlobalSearchLink.defaultProps = {
  ...GlobalSearchLinkDefaultProps,
  linkConfig: {},
};
